import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import moment from 'moment';
import Text from '../text';
import Colors from '../colors';
import Status from '../status';
import Button from '../button';
import Spacer from '../spacer';
import Icon from '../icon';
import Badge from '../badge';
const variants = {
  default: {
    text: 'Use Code',
    bodyColor: {
      text: Colors.gray600,
      date: Colors.gray300,
      icon: Colors.mint400
    }
  },
  applied: {
    text: 'Applied',
    bodyColor: {
      text: Colors.gray600,
      date: Colors.gray300,
      icon: Colors.mint400
    },
    type: 'success',
    icon: 'check-circle',
    borderColor: Colors.mint400
  },
  past: {
    bodyColor: {
      text: Colors.gray300,
      date: Colors.gray100,
      icon: Colors.gray100
    },
    type: 'neutral',
    icon: false
  }
};
const StyledContainer = styled.View`
  flex-direction: row;
  justify-content: flex-start;
  padding: 12px 16px;
  background-color: ${Colors.white};
  border: ${props => props.borderColor ? 2 : 0}px solid ${props => props.borderColor};
  border-radius: 4px;
  width: 100%;
  opacity: ${props => props.disabled && 0.4};
`;
const StyledPair = styled.View`
  flex-direction: column;
  max-width: ${props => props.fullPage ? '100%' : '145px'};
`;
const StyledRow = styled.View`
  flex-direction: row;
`;
const StyledText = styled.Text`
  padding: 3px;
  padding-vertical: 4.17px;
  margin-vertical: auto;
  background-color: ${Colors.purple400};
  color: ${Colors.white};
  border-radius: 50%;
  text-align: center;
  font-size: 13px;
  line-height: 13px;
  font-family: 'LarsseitRegular';
`;
const StyledStatus = styled.View`
  align-self: center;
  margin-left: auto;
`;
const StyledIcon = styled.View`
  width: 32px;
  height: 32px;
  background-color: ${Colors.lightGray200};
  border-radius: 4px;
  justify-content: center;
  align-items: center;
`;
const IconDescriptionContainer = styled.View`
  align-items: flex-start;
  padding-top: 4px;
`;
const StyledDescriptionContainer = styled.View`
  flex-direction: column;
  flex-grow: 2;
`;
const StyledDefaultContainer = styled.View`
  flex-direction: row;
  width: 100%;
`;

const formatDate = date => `Valid until ${moment(date).format('MMM. DD, YYYY')}`;

export default function Voucher(props) {
  const variant = props.applied ? variants.applied : props.past ? variants.past : variants.default;
  return /*#__PURE__*/React.createElement(StyledContainer, {
    borderColor: variant.borderColor,
    disabled: props.disabled
  }, /*#__PURE__*/React.createElement(IconDescriptionContainer, null, /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: "confirmation-number",
    size: 19.17,
    color: variant.bodyColor.icon
  }))), /*#__PURE__*/React.createElement(Spacer, {
    size: "f12",
    width: true
  }), /*#__PURE__*/React.createElement(StyledDescriptionContainer, null, /*#__PURE__*/React.createElement(StyledDefaultContainer, null, /*#__PURE__*/React.createElement(StyledPair, {
    fullPage: props.fullPage
  }, /*#__PURE__*/React.createElement(StyledRow, null, props.children, props.multiple && props.count > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f12",
    width: true
  }), /*#__PURE__*/React.createElement(StyledText, null, "x", props.count))), /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: variant.bodyColor.date
  }, formatDate(props.date))), /*#__PURE__*/React.createElement(StyledStatus, null, props.applied && /*#__PURE__*/React.createElement(Status, {
    type: variant.type,
    icon: variant.icon
  }, variant.text) || props.past && /*#__PURE__*/React.createElement(Status, {
    type: variant.type,
    icon: variant.icon
  }, props.label) || /*#__PURE__*/React.createElement(Button.Text, {
    size: "small",
    onPress: props.useCode
  }, variant.text))), props.limitedOffer && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    height: true
  }), /*#__PURE__*/React.createElement(Badge, {
    type: "information"
  }, "Limited Offer"))));
}
Voucher.propTypes = {
  date: PropTypes.instanceOf(Date),
  children: PropTypes.node,
  limitedOffer: PropTypes.bool,
  multiple: PropTypes.bool,
  count: PropTypes.number,
  applied: PropTypes.bool,
  past: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  useCode: PropTypes.func,
  fullPage: PropTypes.bool
};
Voucher.defaultProps = {
  date: new Date(),
  children: null,
  limitedOffer: false,
  multiple: false,
  count: null,
  applied: false,
  disabled: false,
  past: false,
  label: 'EXPIRED',
  useCode: () => {},
  fullPage: false
};
//# sourceMappingURL=index.js.map